module.exports = __webpack_public_path__ + "static/media/workingmemory-words-11.e7c5acd2.mp3";